import $ from 'jquery';
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { retrieveIndex } from "../../../Services/IndexApiService";
import { useAuthHeader } from '../../../auth/AuthService';

export default function IndexSummary ({STATE}) {
    const {t, i18n} = useTranslation();
    const [index, setIndex] = useState(0);
    const authHeader = useAuthHeader();

    async function updateIndexInfo() {
        await retrieveIndex(authHeader())
        .then((response) => {
            let data = response.data.data;
            setIndex(data.CIndex);
            let lastIndex = data.CIndex - data.CPDay;
            let perChange = (100 * Math.abs(data.CPDay) / lastIndex).toFixed(2);
            $('#index-change').html("&#x25B2; "+ perChange+"%");
            if (data.CPDay > 0) {
                $('#index-change').html("&#x25B2; "+ perChange+"%");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-green")

            } else if (data.CPDay < 0) {
                $('#index-change').html("&#x25BC; "+ perChange+"%");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-red")
            } else {
                $('#index-change').html("&#x25B2; "+ perChange+"%");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-white")
            }
        })
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        updateIndexInfo();
        const intervalIndex = setInterval(updateIndexInfo, 5000);
        if (STATE == 99 || (new Date().setHours(15,10,0)) < (new Date().getTime())) {
            clearInterval(intervalIndex)
        }
        return () => {
            clearInterval(intervalIndex);
        }
    }, [STATE, i18n.language]);

    return (
        <div className="col-6 md:col-4 flex align-items-center">
            <div className="grid m-0 w-full xl:text-5xl lg:text-4xl md:text-2xl text-xl">
                <div className='col-12 pb-0 flex justify-content-center'>
                    <span className="text-white font-bold">{t('CSX Index')}</span>
                </div>
                <div className="col-12 py-0 flex justify-content-center">
                    <span className="text-white font-medium xl:text-5xl lg:text-4xl md:text-2xl text-lg">{ index.toFixed(2) } <span id="index-change"></span></span>
                </div>
            </div>
        </div>
    )
}